module.exports = __webpack_public_path__ + "img/card_intern_trainee_agreements.3d09d80f.svg";